<template>
  <div class="d-flex justify-content-center">
    <Tweet class="flex-fill" :id="mediaObject.id"></Tweet>
  </div>
</template>

<script>
import { Tweet } from 'vue-tweet-embed'
import ExternalMediaObject from './ExternalMediaObject'

export default {
  name: 'TwitterMediaObject',
  components: {Tweet},
  mixins: [ExternalMediaObject]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/socialMedia/TwitterMediaObject.vue